/**
 * @flow
 * */

import styled from 'react-emotion'
import { Typo26PumpkinOrangeDBI } from '../../themes/Fonts/Din2014'
import Colors from '../../themes/Colors'
import { mobile, tabletSpecialUseCase } from '../../utils/mixins'

export const SectionHeading = styled(Typo26PumpkinOrangeDBI)`
  color: ${Colors.twilightBlue};
  text-align: center;
  margin-bottom: 34px;
  ${mobile} {
    font-size: 24px;
  }
  ${tabletSpecialUseCase} {
    font-size: 28px;
  }
  margin-top: 0;
`



// WEBPACK FOOTER //
// ./src/components/TeamNew/styedComponents.js